import { reactive } from 'vue';

export const ToastTypes = {
  ERROR: 'error',
  SUCCESS: 'success',
  INFO: 'info',
  WARNING: 'warning'
} as const;

export type ToastType = (typeof ToastTypes)[keyof typeof ToastTypes];

export interface ToastOptions {
  message: string;
  duration?: number;
  dismissible?: boolean;
  type?: ToastType;
  showIcon?: boolean;
  actionButton?: {
    label: string;
    onClick: () => void;
  } | null;
}

interface ToastState {
  isVisible: boolean;
  message: string;
  dismissible: boolean;
  type: ToastType;
  showIcon: boolean;
  actionButton: ToastOptions['actionButton'];
}

export const toastState = reactive<ToastState>({
  isVisible: false,
  message: '',
  dismissible: false,
  type: 'info',
  showIcon: true,
  actionButton: null
});

export function showToast({
  message,
  duration = 5000,
  dismissible = false,
  showIcon = true,
  type = ToastTypes.INFO,
  actionButton = null
}: ToastOptions): void {
  toastState.message = message;
  toastState.isVisible = true;
  toastState.dismissible = dismissible;
  toastState.type = type;
  toastState.showIcon = showIcon;
  toastState.actionButton = actionButton;

  if (!dismissible) {
    setTimeout(() => {
      toastState.isVisible = false;
    }, duration);
  }
}

export function hideToast(): void {
  toastState.isVisible = false;
}
